module.exports = __webpack_public_path__ + "img/mshoe5.50f6cc83.jpg";